import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
    Button,
} from "reactstrap";
import { Formik, FieldArray } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import FormButtonHandler from "../../../components/FormButtonHandler";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import useCustomValidation from "../validationSchema";
import { getService, editService } from "../../../api/service";

const EditService = () => {
    const { t } = useTranslation();
    const { addServiceSchema } = useCustomValidation();
    const navigate = useNavigate();
    const { id } = useParams();

    const [initialNames, setInitialNames] = useState([""]);

    const { setData, loading, error, success } = useResponse(editService, () => {
        navigate("/services/");
    });

    useEffect(() => {
        const fetchService = async () => {
            try {
                const res = await getService(id);
                const data = res?.data;
                if (data?.names && Array.isArray(data.names) && data.names.length > 0) {
                    setInitialNames(data.names);
                } else {
                    setInitialNames([""]);
                }
            } catch (err) {
                console.error("Failed to fetch service", err);
            }
        };

        fetchService();
    }, [id]);

    return (
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumbs title={`${t("btns.Edit")} ${t("Service")}`} />

                <Formik
                    enableReinitialize
                    initialValues={{ names: initialNames }}
                    validationSchema={addServiceSchema}
                    onSubmit={(values) => {
                        setData({ id, data: values, type: "edit" });
                    }}
                >
                    {(formik) => (
                        <Form
                            className="needs-validation"
                            onSubmit={(e) => {
                                e.preventDefault();
                                formik.handleSubmit();
                            }}
                        >
                            <FieldArray name="names">
                                {(arrayHelpers) => (
                                    <>
                                        {formik.values.names.map((name, index) => (
                                            <Row key={index}>
                                                <Col md="6">
                                                    <FormGroup className="mb-3">
                                                        <Label>
                                                            {t("Name")} {index + 1}
                                                        </Label>
                                                        <Input
                                                            name={`names[${index}]`}
                                                            placeholder={t("Name")}
                                                            type="text"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.names[index]}
                                                            invalid={
                                                                !!(
                                                                    formik.touched.names &&
                                                                    formik.touched.names[index] &&
                                                                    formik.errors.names &&
                                                                    formik.errors.names[index]
                                                                )
                                                            }
                                                        />
                                                        <FormFeedback>
                                                            {formik.errors.names && formik.errors.names[index]}
                                                        </FormFeedback>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="2" className="d-flex align-items-center">
                                                    {index > 0 && (
                                                        <Button
                                                            type="button"
                                                            color="danger"
                                                            onClick={() => arrayHelpers.remove(index)}
                                                        >
                                                            {t("btns.Remove")}
                                                        </Button>
                                                    )}
                                                </Col>
                                            </Row>
                                        ))}
                                        <Button
                                            style={{ marginRight: '20px' }}
                                            type="button"
                                            color="primary"
                                            onClick={() => arrayHelpers.push("")}
                                        >
                                            {t("Add More")}
                                        </Button>
                                    </>
                                )}
                            </FieldArray>

                            <FormButtonHandler btnTxt={t("Update")} loading={loading} />

                            <ResultHandler
                                error={error}
                                success={success}
                                successMsg={t("Updated Successfully!")}
                            />
                        </Form>
                    )}
                </Formik>
            </Container>
        </div>
    );
};

export default EditService;
